module.exports = __webpack_public_path__ + "static/media/hotel_logo.3de91bd0.png";